import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {HttpErrorType, HttpResponseError, HttpTimeoutError} from '../../../services/http/httpError';

/*
 * Props.
 */

export type InlineEditingError = HttpErrorType | Error | undefined;

interface InlineEditingErrorMessageProps {
  /** Error passed from inline editing hook */
  error: InlineEditingError;
  /** Custom error handle, if undefined is return the default error handlers will handle the error */
  onError?: (error: InlineEditingError) => React.ReactElement | undefined;
}

/*
 * Component.
 */

export const InlineEditingErrorMessage: FC<InlineEditingErrorMessageProps> = (props) => {
  const {error, onError} = props;

  if (!error) {
    return null;
  }

  /* Custom Error handling */
  if (onError) {
    const handledError = onError(error);
    if (handledError) {
      return handledError;
    }
  }

  /* Default Error Handlers */
  if (error instanceof HttpResponseError && error.status === 403) {
    return (
      <Trans id="inline-editing-error-not-authorized">You are not authorized to make this change.</Trans>
    );
  }
  if (error instanceof HttpTimeoutError) {
    return <Trans id="inline-editing-error-timed-out">The request timed out. Please try again later.</Trans>;
  }
  return (
    <Trans id="inline-editing-error-unknown-error">
      An unexpected error occured. Please try again later.
    </Trans>
  );
};
